// extracted by mini-css-extract-plugin
export var expanded = "Menu-module--expanded--rhMTS";
export var hasSubmenu = "Menu-module--hasSubmenu--CzQYh";
export var item = "Menu-module--item--YcM9T";
export var menu = "Menu-module--menu--aHnZr";
export var menuToggle = "Menu-module--menuToggle--pgAro";
export var root = "Menu-module--root--YAQsP";
export var subitem = "Menu-module--subitem--8pk1W";
export var submenu = "Menu-module--submenu--1ZGwd";